import React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter as Router } from 'react-router-dom';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { ErrorBoundary } from 'react-error-boundary';

import HeaderNavbar from './components/HeaderNavbar/HeaderNavbar';
import ErrorFallback from './components/ErrorFallback/ErrorFallback';
import Routes from './Routes';
import { NODE_ENV } from './constants/config';
import { HeaderProvider } from './context/HeaderContext';
import { RegionProvider } from './context/RegionContext';
import { logger } from './utils/logger';
import { queryClient } from './store/serverStore';

import './App.scss';

function App() {

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback} onError={logger}>
      <QueryClientProvider client={queryClient}>
        {NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />}
        <Router>
          <HeaderProvider>
            <RegionProvider>
            <div className='appLayout'>
              <header className='appHeader'>
                <HeaderNavbar />
              </header>
              <main className='appMain'>
                <Routes />
              </main>
            </div>
            </RegionProvider>
          </HeaderProvider>
        </Router>
      </QueryClientProvider>
    </ErrorBoundary>
  );

}

export default App;